import { watch, computed } from 'vue';
import Swal from 'sweetalert2';
import { useI18n } from 'vue-i18n';
import { useOnline, useNetwork } from '@vueuse/core';

export const useNetworkStatus = () => {
  const { t } = useI18n();
  const isOnline = useOnline();
  const network = useNetwork();

  let offlineSwal: any = null;

  const isWeak = computed(() => {
    return (
      network.effectiveType.value === 'slow-2g' ||
      network.effectiveType.value === '2g' ||
      (network.downlink.value && network.downlink.value < 0.7)
    );
  });

  watch(
    () => isOnline.value,
    async (online) => {
      if (!online) {
        offlineSwal = Swal.fire({
          text: t('checkNetworkConnection'),
          icon: 'error',
          buttonsStyling: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          heightAuto: false,
          padding: '1rem',
          width: 'auto',
          showConfirmButton: true,
          confirmButtonText: t('tryAgain'),
          customClass: { confirmButton: 'btn btn-primary' },
          didOpen: (toast) => {
            toast.style.fontSize = '0.9rem';
          },
          preConfirm: async () => {
            Swal.showLoading();
            await new Promise((resolve) => setTimeout(resolve, 0));
            return isOnline.value;
          },
          willClose: () => (offlineSwal = null),
        });
      } else if (offlineSwal && Swal.getConfirmButton()?.disabled === false) {
        Swal.clickConfirm();
      }
    },
    { immediate: true }
  );

  watch(
    () => isWeak.value,
    async (weak) => {
      if (weak) {
        Swal.fire({
          toast: true,
          position: 'top-start',
          icon: 'warning',
          title: 'اینترنت ضعیف است!',
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: true,
          allowEscapeKey: true,
          allowEnterKey: false,
          timer: 2000,
          didOpen: (toast) => {
            toast.style.maxWidth = '300px';
            toast.style.minWidth = 'unset';
            toast.style.fontSize = '0.9rem';
          }
        });
      }
    },
    { immediate: true }
  );

  return { isOnline, network };
};